/**
 * Local (compile-time) feature flags — unlike `FEATURE_FLAGS` these are not
 * backend-driven partner features checked via `CheckAccess`/`useHasFeatureFlag`;
 * they only exist in the frontend build. Flip a value to show the hidden
 * sections again (e.g. to preview them while their backend is being built).
 */
const LOCAL_FEATURE_FLAGS = {
  /**
   * Goal sections on the sales dashboards (agent "My goal", manager
   * "Monthly goal"). Targets come from the Laravel goals API since
   * 2026-09-08 (see docs/dashboards-endpoints.md); the flag stays as a kill
   * switch until the release is confirmed.
   */
  DASHBOARD_GOALS: true,
  /**
   * AI-powered preview sections on the sales dashboards: agent coach,
   * anomalies, process quality, reasons for won projects and sales tools.
   * All render mock data (PreviewTag) until their endpoints exist.
   */
  DASHBOARD_AI_SECTIONS: false,
}

export default LOCAL_FEATURE_FLAGS

export type PartnerRolloutFlag = {
  partnerIds: string[];
};

/**
 * Partner-scoped dark launches — resolved at runtime by
 * `hasPartnerRolloutFlag` / `usePartnerRolloutFlag` in `@/utils/access`.
 * A flag is enabled when any of the following holds:
 *   - the build targets a development/testing environment,
 *   - the session is a mimic (support) session,
 *   - the current partner is in the flag's whitelist.
 * Routes are gated by listing the flag under `rolloutFlags` in
 * `typings/roleMapping.ts`. Remove a flag once its feature is generally
 * available.
 */
// Empty: the sales dashboards were the last dark launch and are now generally
// available (gated by `todays_tasks_view` / `analytics_view` instead).
export const PARTNER_ROLLOUT_FLAGS = {} satisfies Record<string, PartnerRolloutFlag>

